import React from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { ExpandLess, ExpandMore } from "../../icons/index";
import { Checkbox, Typography } from "../../index";
var styles = function (theme) { return ({
    headerCell: {
        display: 'flex',
        alignItems: 'center',
    },
    sortIcon: {
        minWidth: 40,
    },
    checkbox: {
        backgroundColor: theme.palette.common.white,
    },
    // 状態
    ellipsis: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
}); };
var useStyles = makeStyles(styles, { name: 'SnDataListTableHeaderCell' });
export var DataListTableHeaderCell = function (props) {
    var _a;
    var cellProps = props.cellProps, sortCondition = props.sortCondition, isAllSelected = props.isAllSelected, onToggleAllSelect = props.onToggleAllSelect;
    var column = cellProps.column;
    var classes = useStyles();
    if (column.format === 'checkbox') {
        return React.createElement(Checkbox, { classes: { border: classes.checkbox }, value: isAllSelected, onChange: onToggleAllSelect });
    }
    var headerCellClassName = classNames(classes.headerCell, classes.ellipsis);
    return (React.createElement("div", { className: headerCellClassName }, (_a = column.headerElement) !== null && _a !== void 0 ? _a : (React.createElement(Typography, { noWrap: true, bold: column.key === (sortCondition === null || sortCondition === void 0 ? void 0 : sortCondition.key) }, column.title)),
        sortCondition && sortCondition.key === column.key && sortCondition.order === 'asc' && (React.createElement(ExpandLess, { className: classes.sortIcon, width: 40, height: 40 })),
        sortCondition && sortCondition.key === column.key && sortCondition.order === 'desc' && (React.createElement(ExpandMore, { className: classes.sortIcon, width: 40, height: 40 }))));
};
